export const PARSED_STATUSES = {
  completed: 'completed',
  error: 'error',
  inProgress: 'in-progress'
};

export const ICON_SIZE = 18;
